module.exports = __webpack_public_path__ + "static/media/section3.5ec4850b.png";